'use strict';

/**
 * Global utility functions for the Seasonic Merch Shop theme.
 */

const utils = {
  isIOS: () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,

  _scrollY: 0,

  /**
   * Locks the body scroll to prevent interaction with the background when a modal is open.
   * Special handling for iOS Safari.
   */
  lockBodyScroll: function () {
    const $body = jQuery('body');
    if (this.isIOS()) {
      this._scrollY = window.scrollY || window.pageYOffset;
      $body.css({
        position: 'fixed',
        top: -this._scrollY + 'px',
        width: '100%',
        left: '0'
      }).addClass('body-scroll-locked');
    } else {
      $body.addClass('body-scroll-locked');
    }
  },

  /**
   * Unlocks the body scroll.
   */
  unlockBodyScroll: function () {
    const $body = jQuery('body');
    if (this.isIOS()) {
      $body.css({
        position: '',
        top: '',
        width: '',
        left: ''
      }).removeClass('body-scroll-locked');
      window.scrollTo(0, this._scrollY);
    } else {
      $body.removeClass('body-scroll-locked');
    }
  },

  /**
   * Universal overlay control.
   * @param {string} selector - The selector for the overlay element.
   * @param {boolean} open - Whether to open or close the overlay.
   */
  setOverlayState: function (selector, open) {
    const $overlay = jQuery(selector);
    if (open) {
      $overlay.addClass('is-open');
      this.lockBodyScroll();
    } else {
      $overlay.removeClass('is-open');
      this.unlockBodyScroll();
    }
  }
};

window.themeUtils = utils;
export default utils;
